import { render, staticRenderFns } from "./audio_fingerprints.vue?vue&type=template&id=03a1073e&"
import script from "./audio_fingerprints.vue?vue&type=script&lang=js&"
export * from "./audio_fingerprints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports